/* eslint-disable no-useless-escape */
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DateValidatorParams } from './date-validator-params';
import { DateTransform } from '@app/shared/utils/date.transform';

export function dateValidator(params: DateValidatorParams, isRequired = false, withTime = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined) {
      return isRequired ? { required: true } : null;
    }

    let pattern = '^\\d{1,2}\\/\\d{1,2}\\/\\d{1,4}';

    if (withTime) {
      pattern += ',?\\s(((0[1-9])|(1[0-2])):([0-5])([0-9])\\s?(A|P)M)';
    }

    pattern += '$';

    const regEx = new RegExp(pattern);

    const stringToCheck: string = value instanceof Date ? value.originalInputString : value;

    const isInvalid =
      control.dirty && stringToCheck && (!regEx.test(stringToCheck) || isNaN(Date.parse(stringToCheck)));

    if (isInvalid) {
      return { isInvalidDate: true };
    }

    const dateValue = new Date(value);

    if (params.min && DateTransform.differenceInSeconds(dateValue, new Date(params.min)) < 0) {
      return { minDate: params.min };
    }

    if (params.max && DateTransform.differenceInSeconds(dateValue, new Date(params.max)) > 0) {
      return { maxDate: params.max };
    }

    return null;
  };
}
